<template>
  <section>
    <v-btn v-on:click="showTestMessageDialog = true" color="info" class="text-none">Test</v-btn>
    <v-dialog persistent v-model="showTestMessageDialog" max-width="600px">
      <v-card>
        <v-card-title primary-title class="headline info">
          <span
            class="title font-weight-light white--text"
          >Send Test Message for {{messagePrettyName}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-autocomplete
              v-model="user"
              :items="users"
              :loading="loading"
              :search-input.sync="search"
              item-text="name"
              label="User"
              placeholder="Search for a User"
              hide-no-data
              hide-selected
              no-filter
              return-object
              prepend-icon="mdi-database-search"
              @change="userSelected"
            ></v-autocomplete>
          </v-container>
          <v-container v-if="showUser && messageType == 'sms'">
            <!-- Maybe display a message for push -->
            <v-card-text
              class="text-xs-center"
            >Sending to {{user.name}} with number: {{user.contact_number}}</v-card-text>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="red darken-1" dark flat @click="handleCancel()">Cancel</v-btn>
          <v-btn class="text-none" color="blue darken-1" dark flat @click="handleTest()">Test</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbarShow" :color="snackbarColor" :timeout="2500">
      <v-card-text class="text-xs-center">{{snackbarMessage}}</v-card-text>
    </v-snackbar>
  </section>
</template>

<script>
import axios from "axios";
import qs from "qs";

export default {
  name: "test_message",
  components: {},
  props: {
    messageKey: String,
    messagePrettyName: String,
    messageType: String
  },
  data: function() {
    return {
      showTestMessageDialog: false,
      showUser: false,
      loading: false,
      users: [],
      user: {},
      search: null,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColor: null
    };
  },
  watch: {
    search(query) {
      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/customer/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          self.users = res.data.customers;
          self.loading = false;
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    }
  },
  methods: {
    userSelected: function(user) {
      this.showUser = true;
    },
    handleTest: function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/notificationConfig/${this.messageType}/sendTestMessage`;
      axios({
        url: url,
        method: "POST",
        data: qs.stringify({
          key: this.messageKey,
          userId: this.user.id
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(response) {
          self.handleCancel();
          if (response.data.error == "no_error") {
            self.snackbarTestMessageSuccessful();
          } else {
            console.log(response.data.error);
            self.snackbarTestMessageFailed();
          }
        })
        .catch(function(error) {
          console.log(error);
          self.handleCancel();
          self.snackbarTestMessageFailed();
        });
    },
    handleCancel: function() {
      this.showTestMessageDialog = false;
      this.showUser = false;
      this.users = [];
      this.user = {};
      this.search = null;
    },
    snackbarTestMessageSuccessful: function() {
      this.snackbarMessage = "Successfully sent test message";
      this.snackbarColor = "success";
      this.snackbarShow = true;
    },
    snackbarTestMessageFailed: function() {
      this.snackbarMessage = "Error sending test message";
      this.snackbarColor = "error";
      this.snackbarShow = true;
    }
  }
};
</script>